import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Button,
  Text,
  Flex,
  Tooltip,
  IconButton,
  Icon,
  Heading,
} from "@chakra-ui/react";
import {
  white,
  newBorder,
  dark,
  primaryAlt,
  buttonRedText,
  buttonRed,
  textPrimary,
  textSecondary,
  primary,
} from "../../../../utils/colors";
import { useTranslation } from "react-i18next";
import PasswordInput from "../../../../components/input/PasswordInput";
import { motion } from "framer-motion";
import Agreement from "../../../../components/partials/Agreement";
import { registerTenantAction } from "../../../../actions/tenantRegisterActions";
import { useDispatch } from "react-redux";

import { FaArrowLeft } from "react-icons/fa6";

const RegisterForm = ({
  language,
  clinicName,
  setClinicName,
  registrationEmail,
  setRegistrationEmail,
  password,
  setPassword,
  repeatPassword,
  setRepeatPassword,
  handleBack,
  loadingRegister,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  // const toastComponent = ToastComponent();

  // ERRORS
  // const isClinicNameError = clinicName === "";

  // Password validation: At least 6 characters and 1 number
  const passwordRegex = /^(?=.*\d).{6,}$/;
  const isPasswordEmpty = password === "";
  const isPasswordInvalid = !passwordRegex.test(password) && !isPasswordEmpty;
  const isPasswordMismatch = password !== repeatPassword && !isPasswordEmpty;

  // Email validation: Standard email format
  const isEmailEmpty = registrationEmail === "";
  const isEmailInvalid =
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(registrationEmail) &&
    !isEmailEmpty;

  // TOOLTIP VALIDATION MESSAGES
  const tooltipMessages = [];

  // if (isClinicNameError)
  //   tooltipMessages.push(t("formError.clinicNameRequired"));
  // Email error messages
  if (isEmailEmpty) {
    tooltipMessages.push(t("formError.emailRequired"));
  } else if (isEmailInvalid) {
    tooltipMessages.push(t("formError.emailInvalid"));
  }

  // Password error messages
  if (isPasswordEmpty) {
    tooltipMessages.push(t("formError.passwordRequired"));
  } else if (isPasswordInvalid) {
    tooltipMessages.push(t("formError.passwordInvalid"));
  }

  // New validation for password mismatch
  if (isPasswordMismatch) {
    tooltipMessages.push(t("formError.passwordMismatch")); // Add this translation key
  }

  // REDUX

  // HANDLERS
  const handleRegister = async (e) => {
    e.preventDefault();
    dispatch(
      registerTenantAction(
        // clinicName,
        registrationEmail,
        password,
        repeatPassword,
        language
      )
    );
  };

  // console.log("language", language);

  return (
    <>
      <Box
        position={["relative", "absolute"]}
        top={["initial", "2rem"]}
        left={[`0rem`, `calc(29% + 2rem)`]}
        zIndex={10000}
      >
        <IconButton
          border={`1px solid ${newBorder}`}
          size="md"
          borderRadius="100rem"
          bg={white}
          fontSize="20px"
          icon={<Icon h="0.875rem" as={FaArrowLeft} />}
          onClick={handleBack}
        />
      </Box>

      <form style={{ width: "100%" }}>
        <Box
          as={motion.div}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          mt={[6, 12]}
        >
          <Heading
            fontSize={["1.875rem", "1.875rem"]}
            fontWeight="700"
            color={textPrimary}
            // mb={6}
          >
            {t("common.registerHeading")}
          </Heading>

          <Text
            color={textSecondary}
            fontWeight="500"
            fontSize={["1.125rem", "md"]}
            m="0.5rem 0 2rem"
          >
            {t("register.intro")}
          </Text>

          <FormControl>
            <FormLabel fontSize="sm" htmlFor="email">
              {t("form.email")}
            </FormLabel>
            <Input
              id="email"
              type="email"
              placeholder={t("placeholder.email")}
              value={registrationEmail}
              textTransform="lowercase"
              bg={white}
              autoComplete="off"
              onChange={
                (e) => setRegistrationEmail(e.target.value) // Set registration email
              }
              size="lg"
              h="3.5rem"
              fontSize="1rem"
              fontWeight="500"
              border={`1px solid ${newBorder}`}
              borderRadius="1rem"
              // placeholder={t("placeholder.email")}
              mb={4}
              _focus={{
                border: `1px solid ${primary}`,
                boxShadow: "none !important",
              }}
            />
          </FormControl>

          <FormControl>
            <FormLabel fontSize="sm" htmlFor="password">
              {t("form.password")}
            </FormLabel>
            <PasswordInput
              id="password"
              name="password"
              value={password}
              onChange={
                (e) => setPassword(e.target.value) // Set password
              }
            />
          </FormControl>

          <FormControl m="1rem 0 1rem">
            <FormLabel fontSize="sm" htmlFor="repeatPassword">
              {t("form.repeatPassword")}
            </FormLabel>
            <PasswordInput
              id="repeatPassword"
              name="repeatPassword"
              value={repeatPassword}
              onChange={
                (e) => setRepeatPassword(e.target.value) // Set repeat password
              }
            />
          </FormControl>
        </Box>

        <Tooltip
          bg={buttonRed}
          color={buttonRedText}
          padding="0.5rem 1rem"
          borderRadius="1rem"
          placement="top"
          label={
            tooltipMessages.length > 0 ? (
              <Flex direction="column" justify="center" align="center">
                {tooltipMessages.map((message, index) => (
                  <Text
                    key={index}
                    color={buttonRedText}
                    fontSize="xs"
                    fontWeight="500"
                    textAlign="center"
                  >
                    {message}
                  </Text>
                ))}
              </Flex>
            ) : null
          }
          isDisabled={tooltipMessages.length === 0} // Disable tooltip if no errors
        >
          <Button
            type="submit"
            onClick={handleRegister}
            isLoading={loadingRegister}
            m="1.5rem 0 "
            // mt={8}
            // mb={4}
            h="3.5rem"
            borderRadius="10rem"
            bg={dark}
            color={white}
            border={`1px solid ${dark}`}
            textAlign="center"
            w="100%"
            _hover={{
              // bg: "rgba(13, 12, 34, 0.8)",
              bg: primaryAlt,
              color: white,
              // border: `rgba(13, 12, 34, 0.8)`,
              border: primaryAlt,
            }}
            isDisabled={tooltipMessages.length > 0} // Disable if any errors exist
          >
            {t("common.register")}
          </Button>
        </Tooltip>
      </form>

      <Agreement />
    </>
  );
};

export default RegisterForm;
